import React from "react";
import { useDarkMode } from "src/context/DarkModeContext";
import PageStructure from "src/components/wrappers/PageStructure";
import ExplanationCard from "src/components/cards/ExplanationCard/ExplanationCard";
import ExampleCard from "src/components/cards/ExampleCard/ExampleCard";
import GrammarComparisonTable from "src/components/tables/GrammarComparisonTable";
import PronounTable from "src/components/tables/PronounTable";
import ExampleTitle from "src/components/ExampleTitle";

import {
    possessiveAdjectivesExplanation,
    possessivePronounsExplanation,
    possessiveAdjectivesTable,
    pronombresPosesivosTable,
    posesivoExamples
} from "src/data/individual-topics/Possessives";


const PossessivesContent: React.FC = () => {
    const { isDarkMode } = useDarkMode();

    return (
        <div className={`${isDarkMode ? "dark" : ""}`}>

            <div className="section">
                <ExplanationCard cardData={possessivePronounsExplanation} />
            </div>

            <div className="section">
                <PronounTable tableData={pronombresPosesivosTable} />
            </div>

            <ExampleTitle />

            <div className="section" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {posesivoExamples.map((example, index) => (
                    <ExampleCard key={index} example={example} />
                ))}
            </div>

            <div className="section">
                <ExplanationCard cardData={possessiveAdjectivesExplanation} />
            </div>

            <div className="section">
                <GrammarComparisonTable tableData={possessiveAdjectivesTable} />
            </div>
        </div>
    );
};

const PossessivesScreen: React.FC = () => {
    return (
        <PageStructure
            TitleNode="Possessive Pronouns"
            Page={<PossessivesContent />}
        />
    );
};

export default PossessivesScreen;
